const PAGINATION = {
    page: 1,
    records: 20
}

export default PAGINATION